import { AnyAction } from 'redux';
import { ApplicationState } from 'app/types-store';
import { ActionDispatching } from 'app/types-shared';
import { STATE } from 'app/constants';
import { ErrorNotification, SuccessNotification } from 'app/infrastructure/notifications/user-messages';
import { isForbiddenStatus, blockAccess } from 'app/area/shared/actions-utils';
import { dashboardAdminTranslation } from '../constants';
import { defaultMaxResults } from './constants';
import {
  ClearList,
  RequestList, ReceiveList, FailList,
  RequestDeleteDashboard, ReceiveDeleteDashboard, FailDeleteDashboard
} from './action-types';
import { api } from './api';
import { mapList } from './map-list';
import { DashboardSearchModel } from './types-store';

export const actionCreators = {

  clearList: (): ActionDispatching<AnyAction, ApplicationState> =>
    (dispatch, getState) => {
      const requestId = Date.now();
      dispatch(new ClearList(requestId));
    },

  loadList: (
    model: DashboardSearchModel,
    startIndex: number = 0,
    maxResults: number = defaultMaxResults
  ): ActionDispatching<AnyAction, ApplicationState> =>
    async (dispatch, getState) => {

      const requestId = Date.now();
      dispatch(new RequestList(requestId, model, startIndex === 0));

      try {
        const listResponse = await api.loadList(model, startIndex, maxResults);

        dispatch(new ReceiveList(requestId, mapList(listResponse.results), listResponse.totalNumberOfResults));
      } catch (err) {
        err && err.userMessages && dispatch(new ErrorNotification(err.userMessages));

        if (isForbiddenStatus(err)) {
          blockAccess({
            dispatch,
            getState,
            area: STATE.dashboardAdministration,
            translationId: dashboardAdminTranslation.no_access_to_dashboard_admin
          });
        }

        dispatch(new FailList(requestId));
      }
    },

  deleteDashboard: (id: number, successMessage: string): ActionDispatching<any, any> =>
    async (dispatch: any, getState: any) => {

      dispatch(new RequestDeleteDashboard(id));

      try {

        await api.deleteDashboard(id);
        dispatch(new ReceiveDeleteDashboard(id));
        dispatch(new SuccessNotification(successMessage));

      } catch (err) {

        if (err && (err.userMessages || err.message)) {
          dispatch(new ErrorNotification(err.userMessages || err.message));
        }
        dispatch(new FailDeleteDashboard(id));
      }
    },

  displayError: (errorMessage: string): ActionDispatching<any, any> =>
    (dispatch, getState) => {
      dispatch(new ErrorNotification(errorMessage));
    }
};
